import { useReducer, type Dispatch } from 'react';
import { PAGE_SIZE } from '../constants.ts';

import { type PhotoNode } from '../types.ts';

export const SET_MODAL_PHOTO = 'SET_MODAL_PHOTO' as const;
export const SET_MODAL_OPEN = 'SET_MODAL_OPEN' as const;
export const INCREASE_MODAL_PAGE = 'INCREASE_MODAL_PAGE' as const;
export const DECREASE_MODAL_PAGE = 'DECREASE_MODAL_PAGE' as const;

type PhotoModalAction =
    | { type: typeof SET_MODAL_PHOTO; photo: PhotoNode; photoIndex: number }
    | { type: typeof SET_MODAL_OPEN; isOpen: boolean }
    | { type: typeof INCREASE_MODAL_PAGE }
    | { type: typeof DECREASE_MODAL_PAGE };

type PhotoModalState = {
    photo: PhotoNode;
    photoIndex: number;
    nextPhotoIndex: number;
    isOpen: boolean;
};

function photoModalReducer(state: PhotoModalState, action: PhotoModalAction): PhotoModalState {
    switch (action.type) {
        case SET_MODAL_PHOTO:
            return {
                ...state,
                photo: action.photo,
                photoIndex: action.photoIndex,
                nextPhotoIndex: action.photoIndex,
            };
        case SET_MODAL_OPEN:
            return { ...state, isOpen: action.isOpen };
        case INCREASE_MODAL_PAGE:
            return {
                ...state,
                nextPhotoIndex: 0,
            };
        case DECREASE_MODAL_PAGE:
            return {
                ...state,
                nextPhotoIndex: PAGE_SIZE - 1,
            };
        default:
            return state;
    }
}

export type UsePhotoModalReducer = {
    modalPhoto: PhotoModalState;
    dispatchModalPhoto: Dispatch<PhotoModalAction>;
};

export function usePhotoModalReducer(): UsePhotoModalReducer {
    const [modalPhoto, dispatchModalPhoto] = useReducer(photoModalReducer, {
        photo: null,
        photoIndex: 0,
        nextPhotoIndex: 0,
        isOpen: false,
    });

    return {
        modalPhoto,
        dispatchModalPhoto,
    };
}
